import React from 'react';

export const LandingPageSubjectMathSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54 0C83.8234 0 108 24.1766 108 54C108 83.8234 83.8234 108 54 108C24.1766 108 0 83.8234 0 54C0 24.1766 24.1766 0 54 0ZM51 6.09277C25.8878 7.64138 6 28.4979 6 54C6 80.5097 27.4903 102 54 102C66.1701 102 77.2795 97.4677 85.7402 90.0029L51.9424 56.7832C51.3398 56.191 51 55.382 51 54.5371V6.09277ZM89.9844 85.7617C96.8419 77.9984 101.229 68.0019 101.907 57H60.7207L89.9844 85.7617ZM57 51H101.907C100.42 26.88 81.12 7.5802 57 6.09277V51Z"
      fill="currentColor"
    />
  </svg>
);

export default LandingPageSubjectMathSvg;
